<template>
  <div class="flex-1 flex flex-col min-h-0 bg-gray-900 w-[210px]">
    <div class="flex-1 flex flex-col pt-6 overflow-y-auto overflow-x-hidden border-r border-gray-800">
      <!-- Logo -->
      <div class="flex items-center pb-12 pl-6">
        <img class="w-[152px]" :src="$logo" :alt="$t('layout.dashboard.logo_alt')" />
      </div>

      <!-- Overview label skeleton -->
      <div class="text-xs text-text-secondary uppercase tracking-[1.5px] pl-6 pb-2.5">
        {{ $t('common.overview') }}
      </div>

      <!-- Navigation items skeleton -->
      <nav class="flex-1 space-y-1">
        <div v-for="i in 12" :key="i" class="flex items-center py-2 h-[36px] text-sm font-medium rounded-r-md mr-4">
          <!-- Icon skeleton -->
          <div class="mr-3 ml-6 flex-shrink-0 h-5 w-5 bg-gray-800 rounded animate-pulse" />
          <!-- Text skeleton -->
          <div class="flex-1 h-4 bg-gray-800 rounded animate-pulse mr-3" />
        </div>
      </nav>

      <!-- Get Started blob skeleton -->
      <div class="p-4">
        <div class="relative inline-block text-left w-full">
          <div>
            <button class="group bg-gray-950 rounded-lg w-full border px-3 py-2 border-gray-800 text-left hover:bg-gray-800 duration-300 focus:outline-none focus:ring-0">
              <span class="flex w-full items-center justify-between">
                <!-- Progress ring skeleton -->
                <div class="z-10 relative w-10 h-10">
                  <div class="w-full h-full bg-gray-800 rounded-full animate-pulse" />
                  <div class="absolute inset-0 flex items-baseline justify-center mt-3" />
                </div>
                <!-- Title skeleton -->
                <div class="h-4 w-20 bg-gray-800 rounded animate-pulse" />
                <!-- Dropdown arrow skeleton -->
                <div class="flex-shrink-0 h-3 w-3 bg-gray-700 rounded animate-pulse" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom team selector skeleton -->
    <div class="flex-shrink-0 flex border-t border-gray-800 border-r">
      <div class="w-full">
        <div class="group w-full text-left text-sm font-medium px-3.5 py-4 border-t border-gray-700 bg-gray-950">
          <span class="flex w-full items-center justify-between">
            <span class="flex min-w-0 items-center justify-between space-x-3">
              <!-- Team logo skeleton -->
              <div class="h-6 w-6 flex-shrink-0 rounded-full bg-gray-800 animate-pulse" />
              <span class="flex min-w-0 flex-1 flex-col">
                <!-- Team name skeleton -->
                <div class="h-4 w-24 bg-gray-800 rounded animate-pulse" />
              </span>
            </span>
            <!-- Dropdown arrow skeleton -->
            <div class="flex-shrink-0 h-4 w-4 bg-gray-800 rounded animate-pulse" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// No props or logic needed - this is a pure skeleton component
</script>
